var big_image;
var transparent = true;

$().ready(function () {
  const labels = document.querySelectorAll(".label-b");
  labels.forEach((label) => {
    const chars = label.textContent.split("");
    label.innerHTML = "";
    chars.forEach((char) => {
      label.innerHTML += `<span>${char === " " ? "&nbsp" : char}</span>`;
    });
  });


  $(".show-modal").click(function () {
    var data = "popups/" + $(this).data("href") + ".html";
    $.get(data, function (ret) {
      $("#modal").removeData("bs.modal");
      $(".modal-content").html(ret);
      $("#modal").modal("show");
    });
  });

  $(".scrollTo").on("click", function (event) {
    var target = $($(this).attr("href"));
    if (target.length) {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 50,
        },
        500
      );
    }
  });

  var selectCol = 0;
  if (selectCol == 0) {
    if ($("body").hasClass("landing-page1")) {
    }
  }
});

$(window).on("scroll", function () {
  responsive = $(window).width();
  if (responsive >= 768) {
    parallax();
    checkScroll();
  }
});

var parallax = debounce(function () {
  no_of_elements = 0;
  $(".parallax").each(function () {
    var $elem = $(this);

    if (isElementInViewport($elem)) {
      var parent_top = $elem.offset().top;
      var window_bottom = $(window).scrollTop();
      var $image = $elem.find(".parallax-background-image");
      var $oVal = (window_bottom - parent_top) / 3;
      $image.css("margin-top", $oVal + "px");
    }
  });
}, 6);

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

function isElementInViewport(elem) {
  var $elem = $(elem);

  // Get the scroll position of the page.
  var scrollElem =
    navigator.userAgent.toLowerCase().indexOf("webkit") != -1 ? "body" : "html";
  var viewportTop = $(scrollElem).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Get the position of the element on the page.
  var elemTop = Math.round($elem.offset().top);
  var elemBottom = elemTop + $elem.height();

  return elemTop < viewportBottom && elemBottom > viewportTop;
}

function checkScroll() {
  if ($(document).scrollTop() > 60) {
    if (transparent) {
      transparent = false;
      $('nav[role="navigation"]')
        .removeClass("navbar-transparent")
        .addClass("navbar-default");
    }
  } else {
    if (!transparent) {
      transparent = true;
      $('nav[role="navigation"]')
        .addClass("navbar-transparent")
        .removeClass("navbar-default");
    }
  }
}

$(".carousel").carousel({
  interval: 2000,
});
